import { TCustomFieldList } from '../../custom-fields/custom-fields.model';

export function findIdByPositionPath(
  path: number[],
  list: TCustomFieldList[] | undefined,
): string | null {
  if (!path.length || !list) {
    return null;
  }
  const [head, ...rest] = path;
  const match = list[head];
  if (!match) {
    return null;
  }
  if (!rest.length) {
    return match.id ?? null;
  }
  return findIdByPositionPath(rest, match.subList);
}
